import { render, staticRenderFns } from "./QAStatus.vue?vue&type=template&id=6c8fb4e6"
import script from "./QAStatus.vue?vue&type=script&lang=js"
export * from "./QAStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports